import React from 'react';
import '../styles/ResourceUpdate.css';
import { FaTimes } from 'react-icons/fa';

export default function ResourceUpdate({ onClose }) {
  return (
    <div className="resource-update-overlay">
      <div className="resource-update-modal">
        {/* Top Nav */}
        <div className="resource-update-header">
          <h2 className="resource-update-title">Resource Update</h2>
          <button className="resource-update-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        {/* Form */}
        <form className="resource-update-form">
          {/* Category & Item Name */}
          <div className="resource-update-row">
            <div className="resource-update-field">
              <label>Category</label>
              <select>
                <option>Supplies</option>
                <option>Inventory</option>
                <option>Equipment</option>
                <option>Others</option>
              </select>
            </div>
            <div className="resource-update-field">
              <label>Item Name</label>
              <input type="text" placeholder="Enter item name" />
            </div>
          </div>

          {/* Item Code & Quantity */}
          <div className="resource-update-row">
            <div className="resource-update-field">
              <label>Item Code</label>
              <input type="text" placeholder="Enter item code" />
            </div>
            <div className="resource-update-field resource-update-quantity">
              <label>Quantity Available</label>
              <div className="resource-update-quantity-group">
                <input type="number" placeholder="0" />
                <select>
                  <option>Pcs</option>
                  <option>Ltr</option>
                  <option>Box</option>
                </select>
              </div>
            </div>
          </div>

          {/* Update Action & Supplier/Vendor */}
          <div className="resource-update-row">
            <div className="resource-update-field">
              <label>Update Action</label>
              <select>
                <option>Add to Stock</option>
                <option>Issued to Staff</option>
                <option>Marked as Used</option>
                <option>Maintenance</option>
                <option>Dispose</option>
                <option>Damage</option>
              </select>
            </div>
            <div className="resource-update-field">
              <label>Supplier / Vendor</label>
              <input type="text" placeholder="Enter supplier/vendor name" />
            </div>
          </div>

          {/* Project Allocation */}
          <div className="resource-update-section">
            <h4>If Resource is allocated to project</h4>
            <div className="resource-update-row">
              <div className="resource-update-field">
                <label>Project Title</label>
                <input type="text" placeholder="Enter project title" />
              </div>
              <div className="resource-update-field">
                <label>Project Code</label>
                <input type="text" placeholder="Enter project code" />
              </div>
            </div>
          </div>

          {/* Remark */}
          <div className="resource-update-field resource-update-remark">
            <label>Remark / Note</label>
            <textarea placeholder="Additional Note"></textarea>
          </div>

          {/* Button */}
          <div className="resource-update-actions">
            <button type="submit">Update Resources</button>
          </div>
        </form>
      </div>
    </div>
  );
}
